/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Consumption status enumeration.
 */
export type ConsumptionStatus = typeof ConsumptionStatus[keyof typeof ConsumptionStatus];


export const ConsumptionStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
} as const;
